export const no_use_competitions = [
  {match_name: 'WTTC亚洲区预选赛',location:'卡塔尔多哈',time:'1月7-13日'},
  {match_name: 'WTT常规挑战赛',location:'南非德班',time:'1月10-15日'},
  {match_name: 'WTT青年常规挑战赛',location:'奥地利林茨',time:'1月11-14日'},
  {match_name: 'WTT 常规挑战赛',location:'卡塔尔多哈',time:'1月15-21日'},
  {match_name: 'WTT 支线赛',location:'卡塔尔多哈',time:'1月22-26日'},
  {match_name: 'WTT青年常规挑战赛',location:'卡塔尔多哈',time:'1月27-30日'},
  {match_name: 'WTT 支线赛',location:'约旦安曼',time:'1月31日-2月4日'},
  {match_name: 'WTT青年球星挑战赛',location:'突尼斯突尼斯市',time:'2月1-5日'},
  {match_name: 'WTT常规挑战赛',location:'约旦安曼',time:'2月6-12日'},
  {match_name: 'WTT支线赛',location:'德国杜塞尔多夫',time:'2月14-17日'},
  {match_name: 'WTT支线赛',location:'德国杜塞尔多夫',time:'2月21-24日'},
  {match_name: 'WTT青年常规挑战赛',location:'葡萄牙维拉雷亚尔',time:'2月25日-3月3日'},
  {match_name: 'WTT球星挑战赛',location:'印度果阿',time:'2月27日-3月5日'},
  {match_name: '新加坡大满贯资格赛',location:'新加坡',time:'3月7-9日'},
  {match_name: '新加坡大满贯赛',location:'新加坡',time:'3月11-19日'},
  {match_name: 'WTT青年常规挑战赛',location:'伊拉克苏莱曼尼亚',time:'3月13-19日'},
  {match_name: 'WTT青年常规挑战赛',location:'土耳其安塔利亚',time:'3月19-25日'},
  {match_name: 'WTT支线赛',location:'土耳其安塔利亚',time:'3月27-4月1日'},
  {match_name: 'WTT青年常规挑战赛',location:'德国柏林',time:'3月27日-4月2日'},
  {match_name: 'WTT青年常规挑战赛',location:'波兰瓦拉迪斯拉沃沃',time:'3月27日-4月2日'},
  {match_name: 'WTT中国系列赛',location:'中国',time:'3月27日-4月9日'},
  {match_name: 'WTT青年球星挑战赛',location:'黑山波德戈里察',time:'4月11-15日'},
  {match_name: 'WTT青年常规挑战赛',location:'比利时斯帕',time:'4月17-23日'},
  {match_name: 'WTT青年常规挑战赛',location:'法国梅茨',time:'4月17-23日'},
  {match_name: 'WTT球星挑战赛',location:'泰国曼谷',time:'4月23-29日'},
  {match_name: 'WTT青年常规挑战赛',location:'西班牙普拉贾·德阿罗',time:'5月10-16日'},
  {match_name: 'WTT青年常规挑战赛',location:'保加利亚帕纳久里什泰',time:'5月15-21日'},
  {match_name: 'WTT青年常规挑战赛',location:'巴拉圭亚松森',time:'5月18-21日'},
  {match_name: 'ITTF世界锦标赛决赛',location:'南非德班',time:'5月20-28日'},
  {match_name: 'WTT青年常规挑战赛',location:'阿根廷罗萨里奥',time:'5月24-27日'},
  {match_name: 'WTT青年常规挑战赛',location:'捷克哈维罗夫',time:'5月29日-6月4日'},
  {match_name: 'WTT青年挑战赛',location:'瑞典赫尔辛堡',time:'6月8-11日'},
  {match_name: 'WTT 常规挑战赛',location:'尼日利亚拉各斯',time:'6月12-18日'},
  {match_name: 'WTT常规挑战赛',location:'突尼斯突尼斯市',time:'6月19-25日'},
  {match_name: 'WTT青年球星挑战赛',location:'秘鲁利马',time:'6月21-25日'},
  {match_name: 'WTT常规挑战赛',location:'克罗地亚萨格勒布',time:'6月26日-7月2日'},
  {match_name: 'WTT青年常规挑战赛',location:'巴西里约热内卢',time:'6月28日-7月1日'},
  {match_name: 'WTT球星挑战赛',location:'斯洛文尼亚卢布尔雅那',time:'7月3-9日'},
  {match_name: '亚洲青年锦标赛',location:'伊拉克索莱曼',time:'7月14-20日'},
  {match_name: 'WTT青年常规挑战赛',location:'哈萨克斯坦阿拉木图',time:'7月25-28日'},
  {match_name: 'WTT青年常规挑战赛',location:'韩国庆阳',time:'7月31日-8月6日'},
  {match_name: 'WTT常规挑战赛',location:'秘鲁利马',time:'7月31日-8月6日'},
  {match_name: 'WTT青年常规挑战赛',location:'美国查尔斯顿',time:'8月1-4日'},
  {match_name: 'WTT常规挑战赛',location:'巴西里约热内卢',time:'8月7-13日'},
  {match_name: 'WTT青年常规挑战赛',location:'中国香港',time:'8月7-13日'},
  {match_name: 'WTT青年挑战赛',location:'约旦安曼',time:'8月20-26日'},
  {match_name: 'WTT支线赛',location:'捷克奥洛穆克',time:'8月22-27日'},
  {match_name: 'WTT青年常规挑战赛',location:'克罗地亚瓦拉日丁',time:'8月28日-9月3日'},
  {match_name: 'WTT青年常规挑战赛',location:' 斯洛文尼亚奥托切克',time:'8月28日-9月3日'},
  {match_name: 'WTT支线赛',location:'保加利亚帕纳久里什泰',time:'8月29日-9月3日'},
  {match_name: '亚洲锦标赛',location:'韩国（待定）',time:'9月3-10日'},
  {match_name: 'WTT青年球星挑战赛',location:'北马其顿斯科普里',time:'9月6-10日'},
  {match_name: 'WTT青年常规挑战赛',location:'泰国曼谷',time:'9月11-17日'},
  {match_name: 'WTT青年常规挑战赛',location:'突尼斯突尼斯市',time:'9月11-17日'},
  {match_name: 'WTT青年常规挑战赛',location:'格鲁吉亚第比利斯',time:'9月18-24日'},
  {match_name: 'WTT青年常规挑战赛',location:'老挝万象',time:'9月20-23日'},
  {match_name: '亚运会',location:'中国杭州',time:'9月23日-10月8日'},
  {match_name: 'WTT青年常规挑战赛',location:'澳大利亚达尔文',time:'9月28日-10月1日'},
  {match_name: 'WTT青年常规挑战赛',location:'黑山波德戈里察',time:'10月4-7日'},
  {match_name: 'WTT青年球星挑战赛',location:'卡塔尔多哈',time:'10月10-14日'},
  {match_name: 'WTT青年常规挑战赛',location:'菲律宾马尼拉',time:'10月15-21日'},
  {match_name: 'WTT青年常规挑战赛',location:'黎巴嫩杰兹',time:'10月19-25日'},
  {match_name: 'WTT青年常规挑战赛',location:'埃及开罗',time:'10月23-29日'},
  {match_name: 'WTT青年常规挑战赛',location:'意大利利加诺',time:'10月29日-11月4日'},
  {match_name: 'WTT冠军赛',location:'德国法兰克福',time:'10月29日-11月5日'},
  {match_name: 'WTT青年常规挑战赛',location:'匈牙利绍姆巴特利',time:'11月2-8日'},
  {match_name: 'WTT青年常规挑战赛',location:'斯洛伐克塞内加尔',time:'11月6-12日'},
  {match_name: 'WTT青年常规挑战赛',location:'厄瓜多尔昆卡',time:'11月11-14日'},
  {match_name: 'WTT青年球星挑战赛',location:'葡萄牙维拉诺瓦德盖亚',time:'11月15-19日'},
  {match_name: 'ITTF世界青年锦标赛',location:'斯洛文尼亚新戈里察',time:'11月26日-12月3日'},
]

export const teamOptions= [
  {
    value: 'men',
    label: '国家乒乓男队',
  },
  {
    value: 'women',
    label: '国家乒乓女队',
  },
  {
    value: 'youth_men',
    label: '国家青年男队',
  },
  {
    value: 'youth_women',
    label: '国家青年女队',
  },
  {
    value: 'mixed',
    label: '国家乒乓混双队',
  },
  {
    value: 'youth_mixed',
    label: '国家青年混双队',
  },
  {
    value: 'foreign_men',
    label: '外协会主要男对手',
  },
  {
    value: 'foreign_women',
    label: '外协会主要女对手',
  },


]

export const compTypeOptions= {
  'men': [
    {value: 'men single', label: '男子单打', abbre:'男单'},
    {value: 'men double', label: '男子双打', abbre:'男双'},


    {value: 'team men', label: '所有团体', abbre:'所有团体'},
    {value: 'team men single', label: '团体男单', abbre:'团体男单'},
    {value: 'team men double', label: '团体男双', abbre:'团体男双'},

    // {value: 'men single with team', label: '男子单打（含团体）', abbre:'男单团'},
    // {value: 'men double with team', label: '男子双打（含团体）', abbre:'男双团'},
  ],
  'women': [
    {value: 'women single', label: '女子单打', abbre:'女单'}, // 这里的默认值 如果不修改 就是单数
    {value: 'women double', label: '女子双打', abbre:'女双'},

    {value: 'team women', label: '所有团体', abbre:'所有团体'},
    {value: 'team women single', label: '团体女单', abbre:'团体女单'},
    {value: 'team women double', label: '团体女双', abbre:'团体女双'},

    // {value: 'women single with team', label: '女子单打（含团体）', abbre:'女单团'},
    // {value: 'women double with team', label: '女子双打（含团体）', abbre:'女双团'},
  ],
  'mix': [{value: 'mixed', label: '混合双打', abbre:'混双'},
    {value: 'team mixed', label: '团体混双', abbre:'团体混双'}]
}

// 这个只是用于翻译的？
export const allSubType = [
  {
    list: ["Men's Singles", "U19 Boys Singles", "U17 Boys Singles", "U15 Boys Singles", "U13 Boys Singles", "U11 Boys Singles",
      "U19 Boys' Singles", "U17 Boys' Singles", "U15 Boys' Singles", "U13 Boys' Singles", "U11 Boys' Singles","Men's Singles Class 6","Men's Singles Class 9"],
    type: "男单",
  },
  {
    list: ["Women's Singles", "U19 Girls Singles", "U17 Girls Singles", "U15 Girls Singles", "U13 Girls Singles", "U11 Girls Singles",
      "U19 Girls' Singles", "U17 Girls' Singles", "U15 Girls' Singles", "U13 Girls' Singles", "U11 Girls' Singles", "Women's Singles Class 9","Women's Singles Class 6"],
    type: "女单",
  },
  {
    list: ["Men's Doubles", "U19 Boys Doubles", "U17 Boys Doubles", "U15 Boys Doubles", "U13 Boys Doubles", "U11 Boys Doubles",
      "U19 Boys' Doubles", "U17 Boys' Doubles", "U15 Boys' Doubles", "U13 Boys' Doubles", "U11 Boys' Doubles"],
    type: "男双",
  },
  {
    list: ["Women's Doubles",  "U19 Girls Doubles", "U17 Girls Doubles", "U15 Girls Doubles", "U13 Girls Doubles", "U11 Girls Doubles",
      "U19 Girls' Doubles", "U17 Girls' Doubles", "U15 Girls' Doubles", "U13 Girls' Doubles", "U11 Girls' Doubles"],
    type: "女双",
  },
  {
    list: ["Mixed Doubles","U19 Mixed Doubles", "U17 Mixed Doubles", "U15 Mixed Doubles", "U13 Mixed Doubles", "U11 Mixed Doubles"],
    type: "混双",
  },
  {
    list: ["Men's Teams","U19 Boys Teams", "U17 Boys Teams", "U15 Boys Teams", "U13 Boys Teams", "U11 Boys Teams", "U19 Boys' Teams", "U17 Boys' Teams", "U15 Boys' Teams", "U13 Boys' Teams", "U11 Boys' Teams"],
    type: "男团",
  },
  {
    list: ["Women's Teams","U19 Girls Teams", "U17 Girls Teams", "U15 Girls Teams", "U13 Girls Teams", "U11 Girls Teams",  "U19 Girls' Teams", "U17 Girls' Teams", "U15 Girls' Teams", "U13 Girls' Teams", "U11 Girls' Teams"],
    type: "女团",
  },
  {
    list: ["Mixed Teams Men's Singles"],
    type: "混团男单",
  },{
    list: ["Mixed Teams Women's Singles"],
    type: "混团女单",
  },{
    list: [ "Mixed Teams Men's Doubles"],
    type: "混团男双",
  },{
    list: ["Mixed Teams Women's Doubles"],
    type: "混团女双",
  },{
    list: ["Mixed Teams Mixed Doubles"],
    type: "混团混双",
  },

]

export const MatchDescription =[
  {key: "Finals", label: '决赛'},
  {key: "Semifinals", label: '半决赛'},
  {key: "Bronze Medal Match",label: "铜牌赛"},
  {key: "Quarterfinals", label: '四分之一决赛'},
  {key: "Round of 16", label: '八分之一决赛'},
  {key: "Round of 32", label: '十六分之一决赛'},
  {key: "Round of 64", label: '三十二分之一决赛'},
  {key: "Round of 128", label: '六十四分之一决赛'},
  {key: "Qualifying Round 1", label: '小组赛第一轮'},
  {key: "Qualifying Round 2", label: '小组赛第二轮'},
  {key: "Qualifying Round 3", label: '小组赛第三轮'},
  {key: "Qualification Round 1", label: '小组赛第一轮'},
  {key: "Qualification Round 2", label: '小组赛第二轮'},
  {key: "Qualification Round 3", label: '小组赛第三轮'},
  {key: "Group 1",label: "团体赛"},
  {key: "Group",label: "团体赛"},
  {key: "Mixed Teams Group",label: "混团团体赛"},
  {key: "OtherRound", label: '其他'},
// --- 新增的条目 (严格按照您的要求添加) ---
  { key: 'QF', label: '四分之一决赛' },
  { key: 'SF', label: '半决赛' },
  { key: 'F', label: '决赛' },
  { key: 'R1', label: '第一轮' },
  { key: 'R2', label: '第二轮' },
  { key: 'R3', label: '第三轮' },
  { key: 'R4', label: '第四轮' },
  { key: 'R16', label: '八分之一决赛' }, // 补充，对应 "Round of 16"
  { key: 'R32', label: '十六分之一决赛' }, // 补充，对应 "Round of 32"
  { key: 'R64', label: '三十二分之一决赛' }, // 补充，对应 "Round of 64"
  // 注意：之前的代码解析出的是 'R 16' (带空格)，这里也补充一下
  { key: 'R 16', label: '八分之一决赛' },
  { key: 'R 32', label: '十六分之一决赛' },
  { key: 'R 64', label: '三十二分之一决赛' },
  { key: 'R 128', label: '六十四分之一决赛' }
]
